export const OfficeCustomEquipmentListState = {
	url: '/custom-equipment',
	title: 'Office Custom Equipment List',
	template: '<custom-equipment-page></custom-equipment-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCustomEquipPageMod" */
			'@Containers/office-custom-equipment-page/office-custom-equipment-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
